import type { JSX } from 'react';
/**
 * 画面全体にインディケーターを表示するコンポーネント
 */
export default function IndicatorScreen(props: { visible: boolean }): JSX.Element {
  return (
    <>
      {props.visible && (
        <div id="loading" style={{ background: 'transparent' }}>
          <div className="sk-chase">
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
            <div className="sk-chase-dot"></div>
          </div>
        </div>
      )}
    </>
  );
}
